import React, { useEffect, useState } from 'react';
import { Detector } from 'react-detect-offline';
import * as Sentry from '@sentry/browser';
import store from 'store';
import eventsPlugin from 'store/plugins/events';

function LogsTracker({ internetConnected }) {
  const [sentryError, _setSentryError] = useState([]);
  const sentryErrorRef = React.useRef(sentryError);

  const setErrors = (data) => {
    sentryErrorRef.current = data;
    _setSentryError(data);
  };

  useEffect(() => {
    store.addPlugin(eventsPlugin);
    const unsubscribe = store.watch('sentryError', (data) => {
      if (!sentryErrorRef.current.includes(data)) {
        setErrors(sentryErrorRef.current.concat(data));
      }
    });

    return () => unsubscribe?.();
  }, []);

  useEffect(() => {
    if (internetConnected && sentryError.filter((err) => !!err).length > 0) {
      // eslint-disable-next-line no-return-await
      sentryError.map(async (err) => {
        console.log('Logging to Sentry:', err);
        const domain = window.location.hostname;
        if (typeof err === 'string') {
          await Sentry.captureMessage(`[${domain}] ${err}`, {
            user: { token: store.get('token') },
            tags: { domain }
          });
        } else {
          await Sentry.captureException(err, {
            user: { token: store.get('token') },
            tags: { domain }
          });
        }
      });
      sentryErrorRef.current = [];
      _setSentryError([]);
      store.remove('sentryError');
    }

  }, [sentryError, internetConnected, _setSentryError]);

  return null;
}
function SentryLogsTracker() {
  return <Detector render={({ online }) => <LogsTracker internetConnected={online} />} />;
}

SentryLogsTracker.defaultProps = {};
SentryLogsTracker.propTypes = {};

export default SentryLogsTracker;
